// Utils
import http from '../../utils/services/http';

// Constants
import { METHODS } from '../../../common/utils/http/httpConstants';
import { PUSH_NOTIFICATION_SUBSCRIPTION_TYPES } from '../../../common/notifications/pushNotificationConstants';
import { isPlatformApple, isPlatformModernMobileApp } from '../../platform/utils/platformDetailsUtils';
import platformSingleton from '../../platform/platformSingleton';

export const registerPushSubscription = ({ subscription, showSuccessNotification }) =>
    http({
        method: METHODS.POST,
        url: 'notifications/push/register',
        data: {
            subscription,
            showSuccessNotification,
            subscriptionType: PUSH_NOTIFICATION_SUBSCRIPTION_TYPES.WEB,
        },
    }).then((res) => res.data);

export const unregisterPushSubscription = async ({ subscription }) => {
    const subscriptionType = isPlatformModernMobileApp(platformSingleton)
        ? isPlatformApple(platformSingleton)
            ? PUSH_NOTIFICATION_SUBSCRIPTION_TYPES.APNS
            : PUSH_NOTIFICATION_SUBSCRIPTION_TYPES.FCM
        : PUSH_NOTIFICATION_SUBSCRIPTION_TYPES.WEB;

    await http({
        method: METHODS.POST,
        url: 'notifications/push/unregister',
        data: {
            subscription,
            subscriptionType,
        },
    }).then((res) => res.data);
};
